import { LangEn } from 'assets/locales/en';
import { Language } from 'assets/locales/fLang';
import { LangFr } from 'assets/locales/fr';

// Same approach as missionTemplate/templateTexts.js: the tabs read the locale
// files in the language Context.js sets for the whole admin.
const language = new Language();
language.loadLanguage(LangFr);
language.loadLanguage(LangEn);
language.setLanguage('fr');

/** A `missionDetail.*` text. */
export const missionDetailText = (key) =>
  language.getValue(`missionDetail.${key}`, '');
